<template>
    <div>

        <div class="caption-join body">
            <div>
                <!-- <img style="width: 16%; margin-left: 18px; float:left" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" />-->
                <center><img style="width: 16%" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" /></center>

                <!--   <img style="width: 18%; float: right; margin-right: 25px"
                alt="Moresi.com"
                src="@/assets/microsoft-logo-png-transparent-20.png" /> -->
            </div>
            <div id="captions-text" class="caption">
                <div v-for="caption in captions" :key="caption.offset">{{ caption.text }}</div>
            </div>
            <div id="language-select">
                <!-- <input type="text"
                v-model="sessionName"
                placeholder="Session Name"
                style="width: 120px" value="accenture"/>-->
                <select v-model="toLanguageCode" style="width: 60px">
                    <option v-for="lang in toLanguageCodes" :value="lang" :key="lang">
                        {{ lang }}
                    </option>
                </select>
            </div>
        </div>
        <div class="footer">

            <div style="text-align:center;">Copyright Moresi.com 2024</div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import constants from '../lib/constants'
    import * as signalR from '@aspnet/signalr'
    import languageListMixin from '../lib/language-list-mixin'

    export default {
        mixins: [languageListMixin],
        props: {
            clientId: String
        },
        data() {
            return {
                code: '',
                captions: [],
                toLanguageCode: 'en',
                sessionName: 'accenture'
            }
        },
        computed: {
            toLanguageCodes() {
                return this.toLanguages.map(l => l.substring(0, 2)).sort()
            }
        },
        methods: {
            async updateLanguageSubscription(languageCode) {
                if (this.sessionName && languageCode) {

                    await axios.post(`${constants.apiBaseUrl}/api/leave`, {
                        userId: this.clientId,
                    });

                    await axios.post(`${constants.apiBaseUrl}/api/selectlanguage`, {
                        languageCode,
                        userId: this.clientId,
                        sessionName: this.sessionName
                    });
                }
            }
        },
        watch: {
            toLanguageCode: {
                handler() {
                    return this.updateLanguageSubscription(this.toLanguageCode)
                },
                immediate: true
            },
            sessionName: {
                handler() {
                    return this.updateLanguageSubscription(this.toLanguageCode)
                }
            }
        },
        async mounted() {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${constants.apiBaseUrl}/api/${this.clientId}`)
                .build()

            this.connection.on('newCaption', onNewCaption.bind(this))

            await this.connection.start()
            console.log('connection started')

            const captionsMap = {}
            var final = false;
            function onNewCaption(caption) {
                console.log(caption);
                if (caption.reason === "TranslatedSpeech") {
                    final = true;
                }

                if (final) {
                    let localCaption = captionsMap[caption.offset]
                    if (!localCaption) {
                        localCaption = captionsMap[caption.offset] = {
                            offset: caption.offset,
                            text: caption.text
                        }

                        this.captions.push(localCaption)
                        this.captions = this.captions.slice(-10);

                    } else {
                        localCaption.text = caption.text;
                    }

                    Vue.nextTick(function () {
                        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
                    })
                    final = false;
                }


            }
        },
        async beforeDestroy() {
            if (this.connection) {
                await Promise.all([
                    this.connection.stop(),
                    this.updateLanguageSubscription(null)
                ])
                console.log('connection stopped')
            }
        }
    }
</script>

<style scoped>
    #language-select {
        top: 0;
        width: 100%;
        padding-top: 5px;
        padding-bottom: 6px;
        background-color: white;
    }

    #captions-text {
        padding-top: 10px;
        padding-bottom: 60px;
    }

    .footer {
        height: 20%;
        margin-top: 20px;
        bottom: 0;
        padding: 10px;
    }

        .footer img {
            width: 20%;
        }

    #nav {
        position: fixed;
        top: 15px;
        width: 100%;
        min-height: 50px;
        z-index: 1000;
        background-color: #fff;
    }

    .caption {
        margin: 28px auto;
        max-width: 1024px;
        font-size: 48px;
        text-align: left;
        padding: 24px;
    }

    #titolo {
        padding-top: 10px;
        padding-bottom: 10px;
        position: fixed;
        width: 100%;
        background-color: #b10000;
        color: white;
        opacity: 0.9;
        z-index: 1000;
        text-align: center;
        top: 0px;
        left: 0px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
</style>